






























































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Action } from "vuex-class";
import constants from "../store/constants";
import anime, { AnimeInstance, easings } from "animejs";
import BackgroundLines from "./BackgroundLines.vue";
import ZingTouch from "zingtouch";
import Viewer from "viewerjs";
import BuyAHouseForm from "./forms/BuyAHouseForm.vue";

@Component({
  components: {
    BuyAHouseForm,
    BackgroundLines
  }
})
export default class HouseInformationWindow extends Vue {
  @State(state => state.app.activeHouseInformationWindow)
  activeHouseInformationWindow!: number;
  viewer: Viewer | null = null;

  $refs!: {
    root: HTMLElement;
    content: HTMLElement;
    images: HTMLElement;
    mobileInfoBlock: HTMLElement;
    container: HTMLElement;
  };

  active = false;
  housesInformation: any[] = [
    // Таунхаус 11
    //****************/
    {
      number: 1,
      name: "Таунхаус 11",
      shortName: "11",
      floors: 2,
      houseArea: "186 м2",
      area: "3,8 сотки",
      parking: 2,
      advantages: ["Выход к лесу", "Терраса и балкон", "Цокольный этаж"],
      price: "4 352 400 грн.",
      promoPrice: null,
      promoEndDate: null
    },

    // Таунхаус А
    //****************/
    {
      number: 2,
      name: "Таунхаус 11а",
      shortName: "11а",
      floors: 2,
      houseArea: "150 м2",
      area: "2,5 сотки",
      parking: 2,
      advantages: ["Выход к лесу", "Терраса и балкон", "Цокольный этаж"],
      price: "3 510 000 грн.",
      promoPrice: null,
      promoEndDate: null
    },

    // Таунхаус Б
    //****************/
    {
      number: 3,
      name: "Таунхаус 11б",
      shortName: "11б",
      floors: 2,
      houseArea: "149 м2",
      area: "2,5 сотки",
      parking: 2,
      advantages: ["Выход к лесу", "Терраса и балкон", "Цокольный этаж"],
      price: "3 486 600 грн.",
      promoPrice: null,
      promoEndDate: null
    },

    // Таунхаус В
    //****************/
    {
      number: 4,
      name: "Таунхаус 11в",
      shortName: "11в",
      floors: 2,
      houseArea: "150 м2",
      area: "2,5 сотки",
      parking: 2,
      advantages: ["Выход к лесу", "Терраса и балкон", "Цокольный этаж"],
      price: "3 510 000 грн.",
      promoPrice: "3 250 000 грн",
      promoEndDate: "30.09.2019"
    },

    // Таунхаус Г
    //****************/
    {
      number: 5,
      name: "Таунхаус 11г",
      shortName: "11г",
      floors: 2,
      houseArea: "185 м2",
      area: "3,8 сотки",
      parking: 2,
      advantages: ["Выход к лесу", "Терраса и балкон", "Цокольный этаж"],
      price: "4 329 000 грн.",
      promoPrice: null,
      promoEndDate: null
    }
  ];

  openSignUpForViewingForm() {
    window.dispatchEvent(new Event("openForm:singUpForViewing"));
  }

  get currentHouse() {
    return this.activeHouseInformationWindow == 0
      ? this.housesInformation[0]
      : this.housesInformation[this.activeHouseInformationWindow - 1];
  }

  close() {
    this.$store.dispatch(constants.changeActiveHouseInformationWindow, 0);
    this.viewer!.exit();
  }

  changeHouse(number: number) {
    this.$store.dispatch(constants.changeActiveHouseInformationWindow, number);
  }

  @Watch("activeHouseInformationWindow")
  activeHouseInformationWindowChange(nextNumber: number, prevNumber: number) {
    if (nextNumber == 0) {
      this.closeWindowHandler();
      return;
    }
    if (prevNumber != 0) {
      this.changeImageHandlerHandler(nextNumber);
    } else if (prevNumber == 0 && nextNumber != 0) {
      this.openWindowHandler(nextNumber);
    }
  }

  mounted() {
    window.addEventListener("keydown", (e: KeyboardEvent) => {
      if (this.active && e.keyCode == 27) {
        this.close();
      }
    });

    this.viewer = new Viewer(this.$refs.images, {
      inline: true,
      rotatable: false,
      toolbar: false,
      navbar: false,
      title: false,
      transition: false,
      view: event => {
        if (this.active && this.activeHouseInformationWindow > 0) {
          this.$store.dispatch(
            constants.changeActiveHouseInformationWindow,
            event.detail.index + 1
          );
        }
      }
    });
  }

  openWindowHandler(imageNumber: number) {
    let infoBlock = this.$refs.root.querySelector<HTMLElement>(".info-block");
    infoBlock!.style.opacity = "0";
    this.active = true;

    this.viewer!.view(imageNumber - 1);
    setTimeout(() => {
      this.$refs.container.classList.add("showed");
      anime({
        targets: infoBlock,
        duration: 600,
        easing: "easeOutQuad",
        opacity: [0, 1],
        delay: 300
      });
    }, 50);
  }

  closeWindowHandler() {
    let infoBlock = this.$refs.root.querySelector<HTMLElement>(".info-block");
    this.$refs.container.classList.remove("showed");
    anime({
      targets: infoBlock,
      easing: "easeOutQuad",
      duration: 300,
      opacity: [1, 0]
    });

    setTimeout(() => {
      this.active = false;
    }, 850);
  }

  changeImageHandlerHandler(nextNumber: number) {
    this.viewer!.view(nextNumber - 1);
  }
}
